import { aes } from '@common/crypter/aes'

// !!! Ezt SOHA nem szabad megváltoztatni !!!
const PASSPHRASE = 's5PNbT8MQ3QDLGpMw9IMNRLMbXhL74rUPyJyzjNz'

type TEncryptReturn = ReturnType<typeof aes.encrypt>
type TDecryptReturn = ReturnType<typeof aes.decrypt>

interface ICrypter {
  encrypt: (str: string) => TEncryptReturn
  decrypt: (str: string) => TDecryptReturn
}

const crypter: ICrypter = {
  /**
   * Egy string encryptelése.
   * @param str - A string, amit encryptelünk.
   */
  encrypt: (str: string): TEncryptReturn => {
    return aes.encrypt(str, PASSPHRASE)
  },

/**
 * Egy string kibontása, encrypt-elt állapotból.
 * @param str - A string, amit ki akarunk bontani.
 */
  decrypt: (str: string): TDecryptReturn => {
    return aes.decrypt(str, PASSPHRASE)
  }
}

export default crypter
